import * as React from "react";
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"

function DragAdvListview() {
  return (
    <svg  width="20" height="20" viewBox="0 0 16 16" cursor="grab">
    <g id="Group_54780" data-name="Group 54780" transform="translate(-3288 19836)">
      <rect id="Rectangle_13630" data-name="Rectangle 13630" width="16" height="16" transform="translate(3288 -19836)" fill="none"/>
      <g id="Group_54776" data-name="Group 54776" transform="translate(3291.5 -19832.5)">
        <circle id="Ellipse_5" data-name="Ellipse 5" cx="1.5" cy="1.5" r="1.5" fill="#c4c4c4"/>
        <circle id="Ellipse_8" data-name="Ellipse 8" cx="1.5" cy="1.5" r="1.5" transform="translate(0 6)" fill="#c4c4c4"/>
        <circle id="Ellipse_6" data-name="Ellipse 6" cx="1.5" cy="1.5" r="1.5" transform="translate(6)" fill="#c4c4c4"/>
        <circle id="Ellipse_7" data-name="Ellipse 7" cx="1.5" cy="1.5" r="1.5" transform="translate(6 6)" fill="#c4c4c4"/>
      </g>
    </g>
  </svg>
  

  );
}

export default DragAdvListview;